import React, { Suspense } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { segmentTrack } from 'flow/actions/segment-actions';
import EmojiPicker from 'flow/pages/messages/EmojiPicker';
import { MessageContent } from 'flow/components/tickets/UseAttachmentHandler';
import { TICKET_STRINGS } from 'flow/utils/segment-utils';

interface EmojiPickerTicketsProps {
    textAreaRef: React.RefObject<HTMLTextAreaElement>;
    messageContent: MessageContent;
    updateMessage: (text: string, caretPosition: number) => void;
    disabled?: boolean;
}

const EmojiPickerTickets = ({
    textAreaRef,
    messageContent,
    updateMessage,
    disabled = false,
}: EmojiPickerTicketsProps) => {
    const dispatch = useAppDispatch();

    const handleEmojiButtonClick = () => {
        dispatch(
            segmentTrack(TICKET_STRINGS.EMOJI_BUTTON_CLICK, {
                component: 'EmojiPicker button',
            }),
        );
    };

    const handleEmojiAdded = () => {
        dispatch(
            segmentTrack(TICKET_STRINGS.ADD_EMOJI_TO_TEXT_FIELD, {
                component: 'EmojiPicker',
            }),
        );
    };

    return (
        <Suspense fallback={<></>}>
            <EmojiPicker
                textAreaRef={textAreaRef}
                messageContent={messageContent}
                updateMessage={updateMessage}
                onEmojiButtonClick={handleEmojiButtonClick}
                onEmojiAdded={handleEmojiAdded}
                className="end-0"
                disabled={disabled}
            />
        </Suspense>
    );
};

export default EmojiPickerTickets;
